/* bc-configurator.js — BlueCube PDP configurator + tag-driven gallery filter (Luxe theme). 2026-08-18.
   Companion to snippets/bc-configurator.liquid. Spec: web/shopify-replatform/pdp-configurator-spec-2026-08-18.md
   No dependencies. Uses Luxe/Dawn globals when present: routes.cart_add_url, publish/PUB_SUB_EVENTS, cart-drawer.renderContents. */
(function () {
  if (customElements.get('bc-configurator')) return;

  const TAG_RE = /\[bc\s+([^\]]*)\]/i;
  const norm = (s) => String(s == null ? '' : s).trim().toLowerCase().replace(/[\s_]+/g, '-');
  const money = (cents, cur) => {
    const n = (cents || 0) / 100;
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur || 'USD', maximumFractionDigits: n % 1 ? 2 : 0 }).format(n); }
    catch (e) { return '$' + n.toLocaleString(); }
  };
  const parseTags = (alt) => {
    const m = TAG_RE.exec(alt || ''); if (!m) return null;
    const out = {};
    m[1].split(/\s+/).filter(Boolean).forEach((tok) => { const i = tok.indexOf('='); if (i < 0) out[norm(tok)] = true; else out[norm(tok.slice(0, i))] = norm(tok.slice(i + 1)); });
    return out;
  };
  const uid = () => 'bc' + Math.random().toString(36).slice(2, 8) + Date.now().toString(36).slice(-4);

  class BcConfigurator extends HTMLElement {
    connectedCallback() {
      if (this._init) return; this._init = true;
      const j = (sel) => { const el = this.querySelector(sel); try { return el ? JSON.parse(el.textContent) : null; } catch (e) { console.warn('bc-configurator: bad JSON in', sel, e); return null; } };
      this.variants = j('[data-bc-variants]') || [];
      this.options = j('[data-bc-options]') || [];
      this.mediaAlt = j('[data-bc-media]') || {};
      this.config = this.dataset.hasConfig === 'true' ? (j('[data-bc-config]') || null) : null;
      this.currency = this.dataset.currency || 'USD';
      this.sectionId = this.dataset.section;
      this.form = document.getElementById(this.dataset.formId);
      this.state = {};      // groupKey -> selected option value ('' for toggle off)
      this.texts = {};      // groupKey -> free text
      this.subpicks = {};   // groupKey -> { subKey: value }
      this.mediaTags = {};
      Object.keys(this.mediaAlt).forEach((id) => { this.mediaTags[id] = parseTags(this.mediaAlt[id]); });
      this.hasTaggedMedia = Object.values(this.mediaTags).some(Boolean);

      if (this.config && Array.isArray(this.config.groups)) {
        this.config.groups.forEach((g) => { this.state[g.key] = g.type === 'toggle' ? '' : (g.default != null ? String(g.default) : (g.options && g.options[0] ? String(g.options[0].value) : '')); });
        this.renderGroups();
        this.hookForm();
        this.renderSaveBuild();
        const info = this.closest('.product__info-container') || this.closest('product-info') || this.parentElement;
        if (info) info.classList.add('bc-has-configurator');
      }
      this.hookVariantChanges();
      this.applyGallery();
      this.restoreFromParam();
      // Luxe re-renders the gallery HTML on variant change (product-info.js updateMedia) — re-apply after any swap.
      const gal = document.getElementById('pageGallery-' + this.sectionId) || document.querySelector('.product-media-component');
      if (gal && window.MutationObserver) {
        this._mo = new MutationObserver(() => { clearTimeout(this._t); this._t = setTimeout(() => this.applyGallery(), 30); });
        this._mo.observe(gal.parentElement || gal, { childList: true, subtree: true });
      }
    }

    /* ---------- current native variant / color ---------- */
    currentVariant() {
      const idInput = this.form && this.form.querySelector('[name="id"]');
      const id = idInput && idInput.value ? String(idInput.value) : null;
      let v = id ? this.variants.find((x) => String(x.id) === id) : null;
      if (!v) v = this.variants.find((x) => x.available) || this.variants[0];
      return v || null;
    }
    selectedNativeOptions() {
      const v = this.currentVariant(); const out = {};
      if (!v) return out;
      this.options.forEach((name, i) => { out[norm(name)] = v['option' + (i + 1)]; });
      return out;
    }
    hookVariantChanges() {
      // Luxe publishes optionValueSelectionChange; also listen to the form's hidden id input and any change in the section as a fallback.
      const re = () => { clearTimeout(this._t2); this._t2 = setTimeout(() => { this.updateTotal(); this.writeTubProps(); this.applyGallery(); }, 60); };
      if (window.subscribe && window.PUB_SUB_EVENTS) {
        try { subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, re); } catch (e) {}
        try { subscribe(PUB_SUB_EVENTS.variantChange, re); } catch (e) {}
      }
      const sec = document.getElementById('MainProduct-' + this.sectionId) || document.getElementById('shopify-section-' + this.sectionId) || this.closest('section') || document;
      sec.addEventListener('change', (e) => { if (e.target && e.target.closest && e.target.closest('variant-selects')) re(); });
      // Luxe swaps variant-selects markup + updates input[name=id] asynchronously — poll the id input briefly after a change.
      if (this.form) {
        let last = (this.form.querySelector('[name="id"]') || {}).value;
        setInterval(() => { const cur = (this.form.querySelector('[name="id"]') || {}).value; if (cur !== last) { last = cur; re(); } }, 400);
      }
    }

    /* ---------- configurator UI ---------- */
    groupVisible(g) {
      if (!g.visible_if) return true;
      return Object.keys(g.visible_if).every((k) => {
        const want = g.visible_if[k]; const have = this.state[k];
        if (Array.isArray(want)) return want.map(String).includes(String(have));
        if (want === '*') return !!have;
        if (want === '!') return !have;
        return String(want) === String(have);
      });
    }
    optionFor(g) { if (!g.options) return null; const v = this.state[g.key]; return g.options.find((o) => String(o.value) === String(v)) || null; }
    includedBy(gKey) { // is group gKey priced-in by an active toggle with includes:[gKey]?
      return (this.config.groups || []).find((g) => g.includes && g.includes.includes(gKey) && this.state[g.key]);
    }
    renderGroups() {
      const root = this.querySelector('[data-bc-groups]'); if (!root) return;
      root.innerHTML = '';
      const primary = document.createElement('div'); primary.className = 'bc-cfg__primary';
      const more = document.createElement('details'); more.className = 'bc-cfg__more';
      const sum = document.createElement('summary'); sum.className = 'bc-cfg__more-summary'; sum.innerHTML = '<span>' + ((this.config.more_label) || 'More options') + '</span><span class="bc-cfg__more-hint" data-bc-more-hint></span>';
      more.appendChild(sum);
      const moreBody = document.createElement('div'); moreBody.className = 'bc-cfg__more-body'; more.appendChild(moreBody);
      let anyMore = false;
      (this.config.groups || []).forEach((g) => {
        const el = this.renderGroup(g);
        if (g.placement === 'more') { moreBody.appendChild(el); anyMore = true; } else primary.appendChild(el);
      });
      root.appendChild(primary);
      if (anyMore) root.appendChild(more);
      this.refreshVisibility();
      this.updateTotal();
      this.writeTubProps();
    }
    renderGroup(g) {
      const wrap = document.createElement('fieldset');
      wrap.className = 'bc-cfg__group bc-cfg__group--' + (g.type || 'choice') + ' bc-cfg__group--' + norm(g.key);
      wrap.dataset.bcGroup = g.key;
      const legend = document.createElement('legend'); legend.className = 'bc-cfg__label';
      legend.innerHTML = '<span class="bc-cfg__label-text">' + (g.label || g.key) + ':</span><span class="bc-cfg__selected" data-bc-selected></span>' + (g.help ? '<span class="bc-cfg__help">' + g.help + '</span>' : '');
      wrap.appendChild(legend);
      const row = document.createElement('div'); row.className = 'bc-cfg__pills'; wrap.appendChild(row);
      const name = 'bc-cfg-' + this.sectionId + '-' + g.key;
      if (g.type === 'toggle') {
        const o = (g.options && g.options[0]) || { value: 'yes', label: g.label, price: 0 };
        row.appendChild(this.pill(g, o, name, 'checkbox'));
      } else {
        (g.options || []).forEach((o) => row.appendChild(this.pill(g, o, name, 'radio')));
      }
      const extra = document.createElement('div'); extra.className = 'bc-cfg__extra'; extra.dataset.bcExtra = g.key; wrap.appendChild(extra);
      return wrap;
    }
    pill(g, o, name, type) {
      const id = name + '-' + norm(o.value);
      const lab = document.createElement('label'); lab.className = 'bc-cfg__pill'; lab.setAttribute('for', id);
      const inp = document.createElement('input'); inp.type = type; inp.name = name; inp.id = id; inp.value = String(o.value); inp.className = 'bc-cfg__input';
      inp.checked = type === 'checkbox' ? !!this.state[g.key] : String(this.state[g.key]) === String(o.value);
      inp.addEventListener('change', () => {
        if (type === 'checkbox') this.state[g.key] = inp.checked ? String(o.value) : '';
        else this.state[g.key] = String(o.value);
        this.onChange(g);
      });
      const price = this.priceLabel(g, o);
      lab.appendChild(inp);
      const span = document.createElement('span'); span.className = 'bc-cfg__pill-body';
      span.innerHTML = '<span class="bc-cfg__pill-title">' + (o.label || o.value) + '</span>' + (o.note ? '<span class="bc-cfg__pill-note">' + o.note + '</span>' : '') + (price ? '<span class="bc-cfg__pill-price" data-bc-price>' + price + '</span>' : '');
      lab.appendChild(span);
      return lab;
    }
    priceLabel(g, o) {
      if (this.includedBy(g.key)) return o.price ? '<s>+' + money(o.price * 100, this.currency) + '</s> included' : '';
      if (!o.price) return o.price === 0 && g.show_zero ? 'included' : '';
      return '+' + money(o.price * 100, this.currency);
    }
    onChange(g) {
      // enforce mutex: if this group has mutex_with, clear those
      if (g.mutex_with && this.state[g.key]) g.mutex_with.forEach((k) => { if (this.state[k]) { this.state[k] = ''; this.syncInputs(k); } });
      this.refreshVisibility();
      this.updateTotal();
      this.writeTubProps();
      this.applyGallery();
    }
    syncInputs(key) {
      const g = (this.config.groups || []).find((x) => x.key === key); if (!g) return;
      const wrap = this.querySelector('[data-bc-group="' + key + '"]'); if (!wrap) return;
      wrap.querySelectorAll('input').forEach((i) => { i.checked = g.type === 'toggle' ? !!this.state[key] : String(i.value) === String(this.state[key]); });
    }
    refreshVisibility() {
      (this.config.groups || []).forEach((g) => {
        const wrap = this.querySelector('[data-bc-group="' + g.key + '"]'); if (!wrap) return;
        const vis = this.groupVisible(g);
        wrap.hidden = !vis;
        if (!vis && this.state[g.key] && g.type === 'toggle') { this.state[g.key] = ''; this.syncInputs(g.key); }
        if (!vis && g.type !== 'toggle' && g.reset_when_hidden) { this.state[g.key] = g.default != null ? String(g.default) : ''; this.syncInputs(g.key); }
        // included-by relabel
        wrap.querySelectorAll('.bc-cfg__pill').forEach((lab) => {
          const inp = lab.querySelector('input'); const o = (g.options || []).find((x) => String(x.value) === inp.value); if (!o) return;
          let pe = lab.querySelector('[data-bc-price]'); const txt = this.priceLabel(g, o);
          if (!pe && txt) { pe = document.createElement('span'); pe.className = 'bc-cfg__pill-price'; pe.setAttribute('data-bc-price', ''); lab.querySelector('.bc-cfg__pill-body').appendChild(pe); }
          if (pe) { pe.innerHTML = txt; pe.hidden = !txt; }
        });
        // selected label
        const sel = wrap.querySelector('[data-bc-selected]'); const o = this.optionFor(g);
        if (sel) sel.textContent = g.type === 'toggle' ? (this.state[g.key] ? 'Added' : '') : (o ? (o.label || o.value) : '');
        // extras: text fields / subpicks for the selected option
        const ex = wrap.querySelector('[data-bc-extra="' + g.key + '"]'); if (ex) this.renderExtras(g, o, ex);
      });
      const hint = this.querySelector('[data-bc-more-hint]');
      if (hint) { const n = (this.config.groups || []).filter((g) => g.placement === 'more' && this.state[g.key] && !(g.type !== 'toggle' && String(this.state[g.key]) === String(g.default))).length; hint.textContent = n ? n + ' selected' : ''; }
    }
    renderExtras(g, o, ex) {
      const active = g.type === 'toggle' ? !!this.state[g.key] : !!o;
      const key = g.key + '|' + (o ? o.value : '');
      if (ex.dataset.rendered === key && active) return;
      ex.innerHTML = ''; ex.dataset.rendered = key;
      if (!active || !o) return;
      if (o.text) {
        const t = o.text; const id = 'bc-cfg-text-' + this.sectionId + '-' + g.key;
        const lab = document.createElement('label'); lab.className = 'bc-cfg__text-label'; lab.setAttribute('for', id); lab.textContent = t.label || 'Details';
        const inp = document.createElement(t.multiline ? 'textarea' : 'input'); if (!t.multiline) inp.type = 'text';
        inp.id = id; inp.className = 'bc-cfg__text field__input'; inp.placeholder = t.placeholder || ''; inp.value = this.texts[g.key] || ''; if (t.required) inp.required = true; inp.maxLength = t.max || 240;
        inp.addEventListener('input', () => { this.texts[g.key] = inp.value; this.writeTubProps(); });
        ex.appendChild(lab); ex.appendChild(inp);
      }
      (o.subpicks || []).forEach((sp) => {
        const sub = document.createElement('div'); sub.className = 'bc-cfg__subpick';
        const lab = document.createElement('div'); lab.className = 'bc-cfg__sub-label'; lab.textContent = sp.label || sp.key; sub.appendChild(lab);
        const row = document.createElement('div'); row.className = 'bc-cfg__pills bc-cfg__pills--sub';
        const cur = (this.subpicks[g.key] || {})[sp.key] || (sp.default != null ? String(sp.default) : String((sp.options[0] || {}).value || ''));
        this.subpicks[g.key] = Object.assign({}, this.subpicks[g.key], { [sp.key]: cur });
        sp.options.forEach((so) => {
          const id = 'bc-cfg-sub-' + this.sectionId + '-' + g.key + '-' + sp.key + '-' + norm(so.value);
          const l = document.createElement('label'); l.className = 'bc-cfg__pill bc-cfg__pill--sub'; l.setAttribute('for', id);
          const i = document.createElement('input'); i.type = 'radio'; i.name = 'bc-cfg-sub-' + this.sectionId + '-' + g.key + '-' + sp.key; i.id = id; i.value = String(so.value); i.className = 'bc-cfg__input'; i.checked = String(so.value) === cur;
          i.addEventListener('change', () => { this.subpicks[g.key][sp.key] = String(so.value); this.writeTubProps(); this.applyGallery(); });
          l.appendChild(i); const s = document.createElement('span'); s.className = 'bc-cfg__pill-body'; s.innerHTML = '<span class="bc-cfg__pill-title">' + (so.label || so.value) + '</span>' + (so.note ? '<span class="bc-cfg__pill-note">' + so.note + '</span>' : ''); l.appendChild(s);
          row.appendChild(l);
        });
        sub.appendChild(row); ex.appendChild(sub);
      });
    }

    /* ---------- pricing / properties / cart lines ---------- */
    activeAddons() { // [{group, option, variant_id, price, props, qty}]
      const out = [];
      (this.config.groups || []).forEach((g) => {
        if (!this.groupVisible(g)) return;
        const o = this.optionFor(g); if (!o) return;
        if (g.type === 'toggle' && !this.state[g.key]) return;
        if (this.includedBy(g.key)) return; // priced inside another add-on
        if (!o.addon || !o.addon.variant_id) return;
        const props = Object.assign({}, o.addon.props || {});
        if (o.text && this.texts[g.key]) props[o.text.name || (g.label + ' details')] = this.texts[g.key];
        (o.subpicks || []).forEach((sp) => { const v = (this.subpicks[g.key] || {})[sp.key]; if (v != null) { const so = sp.options.find((x) => String(x.value) === String(v)); props[sp.prop || sp.label || sp.key] = so ? (so.label || so.value) : v; } });
        // fold included groups' selections into this add-on's props (e.g. commercial package carries Tub material)
        (g.includes || []).forEach((k) => { const ig = (this.config.groups || []).find((x) => x.key === k); const io = ig && this.optionFor(ig); if (ig && io && (ig.type !== 'toggle' || this.state[k])) props[ig.prop || ig.label] = io.label || io.value; });
        out.push({ group: g, option: o, variant_id: o.addon.variant_id, price: Number(o.price || 0), props, qty: 1 });
      });
      return out;
    }
    summaryProps() { // readable properties for the TUB line: every non-default selection
      const props = {};
      (this.config.groups || []).forEach((g) => {
        if (!this.groupVisible(g)) return;
        const o = this.optionFor(g); if (!o) return;
        if (g.type === 'toggle') { if (this.state[g.key]) props[g.prop || g.label] = o.label || 'Yes'; }
        else if (g.always_prop || String(this.state[g.key]) !== String(g.default)) props[g.prop || g.label] = o.label || o.value;
        if (o.text && this.texts[g.key] && (g.type !== 'toggle' || this.state[g.key])) props[o.text.name || (g.label + ' details')] = this.texts[g.key];
        (o.subpicks || []).forEach((sp) => { const v = (this.subpicks[g.key] || {})[sp.key]; if (v != null && (g.type !== 'toggle' || this.state[g.key])) { const so = sp.options.find((x) => String(x.value) === String(v)); props[sp.prop || sp.label || sp.key] = so ? (so.label || so.value) : v; } });
      });
      return props;
    }
    writeTubProps() {
      if (!this.form || !this.config) return;
      this.form.querySelectorAll('input[data-bc-prop]').forEach((i) => i.remove());
      this.querySelectorAll('input[data-bc-prop]').forEach((i) => i.remove());
      const props = this.summaryProps();
      Object.keys(props).forEach((k) => {
        const i = document.createElement('input'); i.type = 'hidden'; i.name = 'properties[' + k + ']'; i.value = props[k]; i.setAttribute('data-bc-prop', ''); i.setAttribute('form', this.dataset.formId);
        this.appendChild(i);
      });
    }
    updateTotal() {
      if (!this.config) return;
      const v = this.currentVariant(); const base = v ? Number(v.price) : 0;
      const adds = this.activeAddons().reduce((s, a) => s + a.price * 100, 0);
      const row = this.querySelector('[data-bc-total-row]'); const el = this.querySelector('[data-bc-total]'); const note = this.querySelector('[data-bc-total-note]');
      if (!row || !el) return;
      row.hidden = false;
      el.textContent = money(base + adds, this.currency);
      if (note) note.textContent = adds ? '(' + money(base, this.currency) + ' base + ' + money(adds, this.currency) + ' options)' : '';
      const btn = this.form && this.form.querySelector('[type="submit"] span'); // keep Luxe's own label; nothing to do
    }
    hookForm() {
      if (!this.form) return;
      // capture-phase listener on the same form fires BEFORE Luxe's product-form.js bubble listener
      this.form.addEventListener('submit', (e) => {
        if (!this.config) return;
        const addons = this.activeAddons();
        // required text check
        const missing = (this.config.groups || []).find((g) => { if (!this.groupVisible(g)) return false; const o = this.optionFor(g); const on = g.type === 'toggle' ? !!this.state[g.key] : !!o; return on && o && o.text && o.text.required && !(this.texts[g.key] || '').trim(); });
        if (missing) { e.preventDefault(); e.stopImmediatePropagation(); const inp = this.querySelector('[data-bc-extra="' + missing.key + '"] .bc-cfg__text'); if (inp) { inp.focus(); inp.reportValidity && inp.reportValidity(); } return; }
        if (!addons.length) return; // no companion lines → let Luxe add the tub (with the hidden properties) as normal
        e.preventDefault(); e.stopImmediatePropagation();
        this.addAll(addons);
      }, true);
    }
    async addAll(addons) {
      const form = this.form; const pf = form.closest('product-form');
      const submit = form.querySelector('[type="submit"]') || (pf && pf.querySelector('[type="submit"]'));
      const spinner = pf && pf.querySelector('.loading__spinner');
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (submit) { submit.setAttribute('aria-disabled', 'true'); submit.classList.add('loading'); }
      if (spinner) spinner.classList.remove('hidden');
      const fd = new FormData(form);
      const v = this.currentVariant(); const qty = Number(fd.get('quantity') || 1) || 1;
      const tubProps = {}; for (const [k, val] of fd.entries()) { const m = /^properties\[(.+)\]$/.exec(k); if (m && val !== '') tubProps[m[1]] = val; }
      const cfgId = uid();
      const optNames = this.options.map((n, i) => v ? v['option' + (i + 1)] : '').filter(Boolean).join(' / ');
      const forLabel = (this.dataset.productTitle || '') + (optNames ? ' — ' + optNames : '');
      tubProps['_bc_config'] = cfgId;
      const items = [{ id: Number(fd.get('id')), quantity: qty, properties: tubProps }];
      addons.forEach((a) => items.push({ id: Number(a.variant_id), quantity: qty * (a.qty || 1), properties: Object.assign({ 'For': forLabel }, a.props, { '_bc_config': cfgId }) }));
      const body = { items };
      if (cart && cart.getSectionsToRender) { body.sections = cart.getSectionsToRender().map((s) => s.id); body.sections_url = window.location.pathname; if (cart.setActiveElement) cart.setActiveElement(document.activeElement); }
      const url = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
      try {
        const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) });
        const json = await r.json();
        if (json.status || json.errors || !r.ok) {
          const msg = json.description || json.message || (json.errors && JSON.stringify(json.errors)) || 'Could not add to cart';
          this.showError(pf, msg);
          if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartError, { source: 'bc-configurator', errors: msg });
          return;
        }
        if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: items[0].id, cartData: json });
        if (cart && cart.renderContents) { json.id = items[0].id; cart.renderContents(json); }
        else window.location = (window.routes && window.routes.cart_url) || '/cart';
      } catch (err) {
        console.error('bc-configurator add', err); this.showError(pf, 'Could not add to cart. Please try again or call us.');
      } finally {
        if (submit) { submit.classList.remove('loading'); submit.removeAttribute('aria-disabled'); }
        if (spinner) spinner.classList.add('hidden');
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      }
    }
    showError(pf, msg) {
      const w = pf && pf.querySelector('.product-form__error-message-wrapper'); if (!w) { alert(msg); return; }
      w.removeAttribute('hidden'); const t = w.querySelector('.product-form__error-message'); if (t) t.textContent = msg;
    }


    /* ---------- saved build: "Email me this build" → receiver /save-build (8/23 ruling: link restores a LIVE cart) + ?bc= restore ---------- */
    buildPayload() {
      const v = this.currentVariant(); if (!v) return null;
      const fd = this.form ? new FormData(this.form) : null; const qty = Number((fd && fd.get('quantity')) || 1) || 1;
      const optNames = this.options.map((n, i) => v['option' + (i + 1)]).filter(Boolean).join(' / ');
      const forLabel = (this.dataset.productTitle || '') + (optNames ? ' — ' + optNames : '');
      const items = [{ variant_id: Number(v.id), qty, sku: v.sku || '', name: (this.dataset.productTitle || '') + (optNames ? ' - ' + optNames : ''), price: Number(v.price) / 100, properties: this.summaryProps() }];
      this.activeAddons().forEach((a) => items.push({ variant_id: Number(a.variant_id), qty: qty * (a.qty || 1), sku: (a.option.addon && a.option.addon.sku) || '', name: (a.option.addon && a.option.addon.title) || (a.group.label + ': ' + (a.option.label || a.option.value)), price: a.price, properties: Object.assign({ 'For': forLabel }, a.props) }));
      const cfg = uid();
      const config = { v: Number(v.id), q: qty, s: Object.assign({}, this.state), t: Object.assign({}, this.texts), sp: JSON.parse(JSON.stringify(this.subpicks || {})), p: location.pathname, cfg, lines: items.map((i) => ({ id: i.variant_id, qty: i.qty, properties: Object.assign({}, i.properties, { '_bc_config': cfg }) })) };
      return { items, config, model: this.dataset.productTitle || '' };
    }
    renderSaveBuild() {
      const row = this.querySelector('[data-bc-total-row]'); if (!row || this.querySelector('[data-bc-save]')) return;
      const box = document.createElement('div'); box.className = 'bc-cfg__save'; box.setAttribute('data-bc-save', '');
      box.innerHTML = '<button type="button" class="bc-cfg__save-btn" data-bc-save-open>Email me this build</button>'
        + '<form class="bc-cfg__save-form" data-bc-save-form hidden novalidate>'
        + '<p class="bc-cfg__save-lead">We’ll email you a link that rebuilds this exact cart — options included.</p>'
        + '<input type="text" name="website" tabindex="-1" autocomplete="off" class="bc-cfg__hp" aria-hidden="true">'
        + '<label>Email *<input type="email" name="email" required autocomplete="email" class="field__input"></label>'
        + '<label>Name<input type="text" name="name" autocomplete="name" class="field__input"></label>'
        + '<label>Phone (optional)<input type="tel" name="phone" autocomplete="tel" class="field__input"></label>'
        + '<p class="bc-cfg__save-err" data-bc-save-err hidden></p>'
        + '<button type="submit" class="button button--secondary bc-cfg__save-submit">Send my build</button></form>'
        + '<p class="bc-cfg__save-done" data-bc-save-done hidden></p>';
      row.insertAdjacentElement('afterend', box);
      const form = box.querySelector('[data-bc-save-form]'); const open = box.querySelector('[data-bc-save-open]');
      open.addEventListener('click', () => { form.hidden = !form.hidden; if (!form.hidden) form.email.focus(); });
      form.addEventListener('submit', (e) => { e.preventDefault(); e.stopPropagation(); this.saveBuild(form, box); });
    }
    async saveBuild(form, box) {
      const err = box.querySelector('[data-bc-save-err]'); const done = box.querySelector('[data-bc-save-done]'); const btn = form.querySelector('[type="submit"]');
      err.hidden = true;
      const email = (form.email.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { err.textContent = 'Please enter a valid email.'; err.hidden = false; form.email.focus(); return; }
      const payload = this.buildPayload(); if (!payload) return;
      const name = (form.name.value || '').trim(); const sp = name.indexOf(' ');
      const a = window.bcAttr ? window.bcAttr() : { attr: null, ga_cid: '', ga_sid: '' };
      const body = { email, first_name: sp > 0 ? name.slice(0, sp) : name, last_name: sp > 0 ? name.slice(sp + 1) : '', phone: (form.phone.value || '').trim(), model: payload.model,
        product_url: location.origin + location.pathname, items: payload.items, config: payload.config, website: form.website.value || '', attr: a.attr, ga_cid: a.ga_cid, ga_sid: a.ga_sid };
      const base = (window.BC_RECEIVER && window.BC_RECEIVER.build) || '';
      btn.disabled = true; btn.classList.add('loading');
      try {
        const r = await fetch(base + '/save-build', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
        const j = await r.json().catch(() => ({}));
        if (!r.ok || !j.ok) throw new Error(j.error || 'Could not save your build right now.');
        form.hidden = true; box.querySelector('[data-bc-save-open]').hidden = true;
        done.innerHTML = 'Sent — check your email for a link that restores this build.' + (j.cart_url ? ' <a href="' + j.cart_url + '">Open it now →</a>' : ''); done.hidden = false;
        if (window.dataLayer) window.dataLayer.push({ event: 'save_build', model: payload.model, value: payload.items.reduce((s, i) => s + i.price * i.qty, 0) });
      } catch (e2) { err.textContent = e2.message || 'Could not save your build right now.'; err.hidden = false; }
      finally { btn.disabled = false; btn.classList.remove('loading'); }
    }
    restoreFromParam() {
      const bc = decodeBc(); if (!bc || !bc.s) return;
      if (bc.p && bc.p !== location.pathname) return;
      const v = this.variants.find((x) => Number(x.id) === Number(bc.v));
      if (v) this.options.forEach((name, i) => {
        const val = v['option' + (i + 1)];
        const vs = document.querySelector('#MainProduct-' + this.sectionId + ' variant-selects') || document.querySelector('variant-selects'); if (!vs) return;
        const radio = Array.from(vs.querySelectorAll('input[type="radio"]')).find((r) => r.value === val);
        if (radio) { if (!radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); } return; }
        const sel = Array.from(vs.querySelectorAll('select')).find((s) => Array.from(s.options).some((o) => o.value === val));
        if (sel && sel.value !== val) { sel.value = val; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      if (bc.q && this.form) { const q = this.form.querySelector('[name="quantity"]'); if (q) q.value = bc.q; }
      const apply = () => {
        if (!this.config) return;
        Object.keys(bc.s || {}).forEach((k) => { if (k in this.state) this.state[k] = String(bc.s[k]); });
        this.texts = Object.assign({}, bc.t || {}); this.subpicks = JSON.parse(JSON.stringify(bc.sp || {}));
        (this.config.groups || []).forEach((g) => this.syncInputs(g.key));
        this.querySelectorAll('[data-bc-extra]').forEach((ex) => { ex.dataset.rendered = ''; });
        const more = this.querySelector('.bc-cfg__more');
        if (more && (this.config.groups || []).some((g) => g.placement === 'more' && this.state[g.key] && String(this.state[g.key]) !== String(g.default))) more.open = true;
        this.refreshVisibility(); this.updateTotal(); this.writeTubProps(); this.applyGallery();
      };
      apply(); setTimeout(apply, 700); // Luxe re-renders variant-selects asynchronously; re-apply once it settles
      this.classList.add('bc-cfg--restored');
    }
    /* ---------- gallery filter ---------- */
    filterState() {
      const st = Object.assign({}, this.selectedNativeOptions()); // e.g. color, size (lowercased keys, raw values)
      Object.keys(st).forEach((k) => { st[k] = norm(st[k]); });
      const defaults = {}; const sub = {};
      if (this.config) (this.config.groups || []).forEach((g) => {
        const vis = this.groupVisible(g); const o = vis ? this.optionFor(g) : null;
        // subpick media keys (e.g. commercial package -> tub material) — collected for EVERY active option, applied after the
        // loop so they win over the (hidden, reset) standalone group. 8/26 fix: this used to sit behind the media_key gate,
        // and the package toggle has no media_key of its own, so the C3X tub sub-pick never reached the gallery.
        const on = g.type === 'toggle' ? (vis && !!this.state[g.key]) : !!o;
        if (on && o && o.subpicks) o.subpicks.forEach((sp) => { if (sp.media_key) { const v = (this.subpicks[g.key] || {})[sp.key]; const vv = v != null ? v : sp.default; if (vv != null) sub[norm(sp.media_key)] = norm(vv); } });
        if (!g.media_key) return;
        let val = '';
        if (g.type === 'toggle') val = (vis && this.state[g.key]) ? norm(o && o.media_value != null ? o.media_value : (o ? o.value : 'yes')) : norm(g.media_off != null ? g.media_off : 'none');
        else val = o ? norm(o.media_value != null ? o.media_value : o.value) : '';
        st[norm(g.media_key)] = val;
        defaults[norm(g.media_key)] = g.type === 'toggle' ? norm(g.media_off != null ? g.media_off : 'none') : norm(g.default != null ? g.default : '');
      });
      Object.assign(st, sub);
      return { st, defaults };
    }
    applyGallery() {
      if (!this.hasTaggedMedia) return;
      const { st, defaults } = this.filterState();
      const scoreAll = (state) => {
        const scored = {}; let anyMatch = false;
        Object.keys(this.mediaTags).forEach((id) => {
          const t = this.mediaTags[id];
          if (!t) { scored[id] = null; return; }              // untagged
          if (t.always) { scored[id] = { show: true, score: -1 }; return; }
          let ok = true, score = 0;
          Object.keys(t).forEach((k) => {
            if (k === 'view' || k === 'always' || k === 'model' || k === 'seq') return;
            if (!(k in state)) return;                        // dimension unknown on this product → ignore
            if (state[k] === '' ) return;                     // nothing selected for this dim → agnostic
            if (t[k] !== state[k]) ok = false;
            else if (defaults[k] !== undefined && state[k] !== defaults[k]) score += 2; else score += 1;
          });
          scored[id] = { show: ok, score };
          if (ok) anyMatch = true;
        });
        return { scored, anyMatch };
      };
      let { scored, anyMatch } = scoreAll(st);
      // Selected color has no renders (e.g. Custom) → fall back to the first color that
      // HAS tagged media, like the WP configurator showed its default set.
      if (!anyMatch && st.color) {
        const firstTaggedColor = (Object.values(this.mediaTags).find((t) => t && t.color) || {}).color;
        if (firstTaggedColor && firstTaggedColor !== st.color) {
          ({ scored, anyMatch } = scoreAll(Object.assign({}, st, { color: firstTaggedColor })));
        }
      }
      const nodes = document.querySelectorAll('[data-media-id]');
      if (!nodes.length) return;
      let best = null, bestScore = -Infinity;
      nodes.forEach((n) => {
        const id = String(n.getAttribute('data-media-id')); const s = scored[id];
        let show;
        if (!anyMatch) show = true;                          // nothing tagged matches → show everything (pre-render / unknown combo)
        else if (s === null || s === undefined) show = false; // untagged hidden once tagged media exist
        else show = s.show;
        n.classList.toggle('bc-media-hidden', !show);
        if (n.tagName === 'BUTTON' || n.classList.contains('lightbox-thumbnail')) n.hidden = !show;
        if (show && s && s.score > bestScore && n.classList.contains('product-media-image')) { bestScore = s.score; best = n; }
      });
      // thumbnails carry data-slide-index but not always data-media-id → mirror by index
      const slides = Array.from(document.querySelectorAll('#SlidesCon .product-media-image[data-slide-index]'));
      const hiddenIdx = new Set(slides.filter((s) => s.classList.contains('bc-media-hidden')).map((s) => s.getAttribute('data-slide-index')));
      // (skip nodes that carry data-media-id — the pass above already handled them, and the
      // lightbox thumbnails' data-slide-index is off-by-one vs the slides in Luxe markup)
      document.querySelectorAll('.gallery-slider--thumbnail[data-slide-index], .lightbox-thumbnail[data-slide-index]').forEach((t) => { if (t.hasAttribute('data-media-id')) return; const hide = hiddenIdx.has(t.getAttribute('data-slide-index')); t.classList.toggle('bc-media-hidden', hide); t.hidden = hide; });
      // scroll the slider to the best-matching visible slide (e.g. the walnut-deck shot when Walnut is picked)
      if (best && anyMatch) {
        const con = document.getElementById('SlidesCon');
        if (con && !best.classList.contains('bc-media-hidden')) {
          const idx = best.getAttribute('data-slide-index');
          const thumb = document.querySelector('.gallery-slider--thumbnail[data-slide-index="' + idx + '"]');
          if (window.changeSlide && thumb) { try { changeSlide(thumb, Number(idx)); } catch (e) { con.scrollTo({ left: best.offsetLeft }); } }
          else con.scrollTo({ left: best.offsetLeft });
        }
      }
    }
  }

  /* ?bc=<base64url JSON> — written by the receiver onto the cart permalink; read on the PDP (restore picks) and on /cart (restore properties). */
  function decodeBc() {
    try {
      const m = /[?&]bc=([^&]+)/.exec(location.search); if (!m) return null;
      let s = decodeURIComponent(m[1]).replace(/-/g, '+').replace(/_/g, '/'); while (s.length % 4) s += '=';
      return JSON.parse(decodeURIComponent(escape(atob(s))));
    } catch (e) { console.warn('bc: bad bc param', e); return null; }
  }
  /* /cart?bc=… landing from the saved-build email: rebuild the LIVE cart here, with line-item properties.
     (Shopify's native /cart/{variant}:{qty} permalink jumps straight to CHECKOUT and drops properties — verified 8/26 — so the
     receiver links to /cart?bc= instead and this script adds the lines via /cart/add.js. A native permalink that does land here is handled too.) */
  (function () {
    if (!/^\/cart\/?$/.test(location.pathname)) return;
    const bc = decodeBc(); if (!bc || !Array.isArray(bc.lines) || !bc.lines.length) return;
    const key = 'bc_restored_' + (bc.cfg || ''); try { if (sessionStorage.getItem(key)) return; } catch (e) {}
    const H = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    fetch('/cart.js', { headers: H }).then((r) => r.json()).then((cart) => {
      const items = cart.items || [];
      if (items.some((it) => it.properties && it.properties._bc_config === bc.cfg)) return 0;   // already restored
      const pending = bc.lines.slice(); const fix = [];
      items.forEach((it, idx) => {                                                             // native-permalink case: same variants, no properties
        const i = pending.findIndex((l) => Number(l.id) === Number(it.variant_id) && !(it.properties && it.properties._bc_config));
        if (i < 0) return; fix.push({ line: idx + 1, quantity: it.quantity, properties: pending[i].properties }); pending.splice(i, 1);
      });
      const add = pending.map((l) => ({ id: Number(l.id), quantity: Number(l.qty || 1), properties: l.properties }));
      let p = fix.reduce((q, t) => q.then(() => fetch('/cart/change.js', { method: 'POST', headers: H, body: JSON.stringify(t) })), Promise.resolve());
      if (add.length) p = p.then(() => fetch('/cart/add.js', { method: 'POST', headers: H, body: JSON.stringify({ items: add }) }).then((r) => r.json()).then((j) => { if (j.status || j.errors) throw new Error(j.description || j.message || 'add failed'); }));
      return p.then(() => fix.length + add.length);
    }).then((n) => {
      try { sessionStorage.setItem(key, '1'); } catch (e) {}
      if (n) { const u = new URL(location.href); u.searchParams.delete('bc'); history.replaceState(null, '', u.toString()); location.reload(); }
    }).catch((e) => console.warn('bc saved-build restore', e));
  })();
  customElements.define('bc-configurator', BcConfigurator);
})();
